'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCouponsIfNeeded = exports.failureCoupons = exports.receiveCoupons = exports.requestCoupons = exports.invalidateCoupons = exports.filterCoupons = exports.INVALIDATE_COUPONS = exports.FILTER_COUPONS = exports.FAILURE_COUPONS = exports.RECEIVE_COUPONS = exports.REQUEST_COUPONS = undefined;

var _api = require('../api');

var REQUEST_COUPONS = exports.REQUEST_COUPONS = 'REQUEST_COUPONS'; /**
                                                                    * 优惠券相关Actions
                                                                    */
var RECEIVE_COUPONS = exports.RECEIVE_COUPONS = 'RECEIVE_COUPONS';
var FAILURE_COUPONS = exports.FAILURE_COUPONS = 'FAILURE_COUPONS';
var FILTER_COUPONS = exports.FILTER_COUPONS = 'FILTER_COUPONS';
var INVALIDATE_COUPONS = exports.INVALIDATE_COUPONS = 'INVALIDATE_COUPONS';

var filterCoupons = exports.filterCoupons = function filterCoupons(filter) {
    return {
        type: FILTER_COUPONS,
        filter: filter
    };
};

var invalidateCoupons = exports.invalidateCoupons = function invalidateCoupons(filter) {
    return {
        type: INVALIDATE_COUPONS,
        filter: filter
    };
};

var requestCoupons = exports.requestCoupons = function requestCoupons(filter) {
    return {
        type: REQUEST_COUPONS,
        filter: filter
    };
};

var receiveCoupons = exports.receiveCoupons = function receiveCoupons(filter, json) {
    var coupons = json.data;
    return {
        type: RECEIVE_COUPONS,
        coupons: coupons,
        pagination: json.meta ? json.meta.pagination : {}
    };
};

var failureCoupons = exports.failureCoupons = function failureCoupons(error) {
    return {
        type: FAILURE_COUPONS,
        error: error
    };
};

var shouldFetchCoupons = function shouldFetchCoupons(state, filter) {
    var coupons = state.coupon.coupons;
    if (coupons.items.length === 0) {
        return true;
    }
    if (coupons.isFetching) {
        return false;
    }
    return true;
};

var fetchCouponsIfNeeded = exports.fetchCouponsIfNeeded = function fetchCouponsIfNeeded(filter, page) {
    return function (dispatch, getState) {
        if (shouldFetchCoupons(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestCoupons(filter));
                return (0, _api.fetchCoupons)(filter, page).then(function (response) {
                    return dispatch(receiveCoupons(filter, response.data));
                }).catch(function (error) {
                    return dispatch(failureCoupons(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/coupon.js
// module id = 912
// module chunks = 0